<template>
    <el-dialog 
        :title="(categoryId == null ? $t('common.create') : $t('common.update')) + ' ' + $t('common.category')" 
        :visible.sync="showDialog" 
        @open="loadCategory" 
        @close="closeDialog" 
        width="500px" 
        :close-on-click-modal="false">
        <el-form 
            v-loading="loading" 
            ref="form" 
            :model="form" 
            :rules="rules" 
            size="small" 
            label-width="140px" 
            label-position="left">
            <el-form-item :label="$t('common.product')" prop="productId">
                <product-selector v-model="form.productId"></product-selector>
            </el-form-item>

            <el-form-item :label="$t('common.name')" prop="name">
                <el-input v-model="form.name"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer">
            <el-button 
                :disabled="loading" 
                type="primary" 
                @click="save" 
                v-if="$isFullAdmin">
                {{categoryId === null ? $t('common.create') : $t('common.update')}}
            </el-button>
            <el-button 
                :disabled="loading" 
                @click="closeDialog">
                {{$t('common.cancel')}}
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { ProductSelector } from '@/app/shared/components'
    import api from '../api'

    export default {
        name: 'create-update-resolution-code-category-dialog',
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            categoryId: {
                required: false
            }
        },
        components: {
            ProductSelector
        },
        data() {
            return {
                form: {
                    productId: undefined,
                    name: '',
                },
                rules: {
                    productId: [
                        {
                            type: 'number',
                            required: true,
                            message: this.$t('common.pleaseSelectProduct'),
                            trigger: 'change'
                        }
                    ],
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterName'),
                            trigger: 'blur'
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val
            }
        },
        methods: {
            loadCategory() {
                if (this.categoryId) {
                    this.loading = true
                    api.getCategory(this.categoryId).then(response => {
                        this.loading = false
                        this.form = Object.assign({}, response.data)
                    }).catch(() => {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: this.$t('common.errorLoadingData')
                        });
                    })
                }
            },
            closeDialog() {
                this.$refs['form'].resetFields()
                this.showDialog = false
                this.loading = false
                this.$emit('dialogClosed')
            },
            save() {
                this.$refs['form'].validate(valid => {
                    if (valid) {
                        this.loading = true
                        api.saveCategory(this.categoryId, this.form).then(() => {
                            this.loading = false
                            this.$emit('save', {
                                new: this.categoryId === undefined,
                                id: this.categoryId,
                                data: this.form
                            })
                            this.$message({
                                type: 'success',
                                message: this.categoryId == null ? 
                                    this.$t('masters.categoryCreated') : 
                                    this.$t('masters.categoryUpdated')
                            });
                            this.closeDialog()
                        }).catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: this.$t('common.errorSavingData')
                            });
                        })
                    } else {
                        return false
                    }
                })
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/resolutioncodes/components/CreateUpdateResolutionCodeCategoryDialog.vue